<sn-fab-button
  class="actions"
  matTooltip="Actions"
  [matMenuTriggerFor]="menu"
  #trigger="matMenuTrigger"
  *ngIf="isDocked"
>
  <sn-icon>menu</sn-icon>
</sn-fab-button>

<mat-menu #menu="matMenu">
  <button mat-menu-item *ngIf="device" (click)="followMode()">
    <sn-icon fontSet="fs" fontIcon="Icon_Tether"></sn-icon>
    {{
      this.axonService.deviceInFollowMode === this.device
        ? 'Leave Follow Mode'
        : 'Enter Follow Mode'
    }}
  </button>
  <button mat-menu-item *ngIf="device" (click)="deviceHistory()">
    <sn-icon fontSet="fal" fontIcon="fa-clock-rotate-left"></sn-icon>
    Device History
  </button>
  <button mat-menu-item *ngIf="device" (click)="openPopout()">
    <sn-icon fontSet="fal" fontIcon="fa-play"></sn-icon>
    Open Popout
  </button>
</mat-menu>
<div class="iframeContainer"></div>
